angular.module('ihestiaMenuBase')
    .directive('taskCounter', [
        function() {
            return {
                restrict: 'E',
                templateUrl: 'ihestia-menu-template-app/taskCounter/taskCounter.tpl.html'
            };
        }
    ]);
